import {createStore} from "effector";

export const $authStatus = createStore(false)

export const $signedCert = createStore(null)

export const $regSuccess = createStore(false)